module.exports = __webpack_public_path__ + "static/img/trrafic-stay-icon.f770cce1.svg";